export const SERVICE_REDUCER_NAMES = {
  LOADERS: 'loaders',
  MODALS: 'modals',
};
